var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19602 13.1261V8.89469H1.13741C0.896226 8.89469 0.71534 8.80204 0.594749 8.61672C0.474159 8.4314 0.468678 8.22549 0.578306 7.999L4.72223 0.586316C4.89763 0.298045 5.14978 0.195091 5.47866 0.277454C5.80754 0.359817 5.97198 0.565725 5.97198 0.895178V5.18835H8.83326C9.07444 5.18835 9.26081 5.28616 9.39237 5.48177C9.52392 5.67739 9.53488 5.87815 9.42525 6.08405L5.44577 13.4041C5.27037 13.6923 5.01822 13.8004 4.68934 13.7284C4.36046 13.6563 4.19602 13.4556 4.19602 13.1261Z",
    fill: "#00672C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningGreenIcon);
export default __webpack_public_path__ + "static/media/lightning_green_icon.896225cc9d2548a99982b85c27a51345.svg";
export { ForwardRef as ReactComponent };